import { TPayPackageGift } from '../../../../../../PayPackageMicrofrontend';
import {
  ERecommendedPackageGiftType,
  IRecommendedPackageCashbackGift,
  IRecommendedPackageVasGift,
  TRecommendedPackageGift,
} from '../../../../../types/reducers/recommendedPackages';
import { mapVasGifts } from './mapVasGifts';

interface IResult {
  cashback: number | null;
  cashbackPercent: number | null;
  gifts: Array<TPayPackageGift>;
}

export const mapGifts = (gifts: Array<TRecommendedPackageGift>): IResult => {
  let cashback: number | null = null;
  let cashbackPercent: number | null = null;

  const vasGifts = gifts.filter(
    gift => gift.type === ERecommendedPackageGiftType.Vas,
  ) as Array<IRecommendedPackageVasGift>;
  const cashbackGift = gifts.find(
    gift => gift.type === ERecommendedPackageGiftType.Cashback,
  ) as IRecommendedPackageCashbackGift;

  if (cashbackGift) {
    cashback = cashbackGift.auctionPoints;
    cashbackPercent = cashbackGift.cashbackPercent;
  }

  return {
    cashback,
    cashbackPercent,
    gifts: mapVasGifts(vasGifts),
  };
};
